import React from "react";
import "./GameStep.scss";

const GameStep = ({ step, title, description, image, visual }) => {
  // `visual` is a self-contained React node (e.g. an inline SVG diagram)
  // rendered in place of an <img>. Panel 3 uses this for the survival
  // entries table instead of a captured screenshot; `image` stays
  // available for panels that use a plain picture (panel 2).
  return (
    <div className="game-steps position-relative">
      <div className="game-steps-text">
        <div className="font-cairo-extrabold game-steps-text-step">
          {step}
        </div>
        {title && (
          <div className="font-cairo-extrabold game-steps-text-title text-start">
            {title}
          </div>
        )}
        <div className="font-cairo-bold game-steps-text-join text-start">
          {description}
        </div>
        {visual ? (
          // v5's table (captions removed) no longer needs panel 3's old
          // 216px special case — its own viewBox is sized to its content
          // and centers within whatever height it's given (see
          // SurvivalTable.jsx), so this now matches panel 2's plain
          // 240px image height exactly, no step-based branching left.
          <div className="game-steps-image" style={{ height: "240px" }}>
            {visual}
          </div>
        ) : (
          image && (
            <div className="game-steps-image" style={{ height: "240px" }}>
              <img src={image} alt="Step Icon" className="image-cover-full" />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default GameStep;
